import React from 'react';

import Container from 'react-bootstrap/Container';

import PoweredBy from '../Component/General/PoweredBy';

interface Props {
    message?: string;
}

const ForbiddenPage: React.FC<Props> = ({ message }: Props) => (
    <>
        <Container className="loading-container">
            <div className="loading-container__not-found">
                <h2>Geen toegang</h2>
                <strong>{message ?? 'De toegang is verlopen, klik opnieuw op de toegangslink.'}</strong>
            </div>
        </Container>
        <PoweredBy />
    </>
);

export default ForbiddenPage;
